import { useSelector } from 'react-redux';

import { langLocaleSelector } from './selectors';

export function useGetLangLocale() {
  return useSelector(langLocaleSelector);
}
